import React from "react";
import { CaretLeftFill, CaretRightFill } from "react-bootstrap-icons";
import styles from "./ShelfNavigator.module.css";
import { ArrowButton } from "../../../components/ArrowButton";
import { allWarehouseHeights } from "../../../constants";
import { HelpText } from "../../../components/HelpText";

interface Props {
  selectedShelf: string;
  groups: string[];
  onSelect: (shelf: string) => void;
  onNext: (dir: number) => void;
}

export const ShelfNavigator = ({ selectedShelf, groups, onSelect, onNext }: Props) => {
  return (
    <>
      <div className={styles.wrapper}>
        <ArrowButton onClick={() => onNext(-1)}>
          <CaretLeftFill size={20} color="white" />
        </ArrowButton>

        <select className={styles.select} value={selectedShelf} onChange={(e) => onSelect(e.target.value)}>
          <option value="">Wybierz</option>
          {groups.map((g) => (
            <optgroup label={g} key={g}>
              {allWarehouseHeights
                .filter((s) => s.shelf.startsWith(g))
                .sort((a, b) => a.shelf.localeCompare(b.shelf))
                .map((shelf) => (
                  <option value={shelf.shelf} key={shelf.shelf}>
                    {shelf.shelf}
                  </option>
                ))}
            </optgroup>
          ))}
        </select>

        <ArrowButton onClick={() => onNext(1)}>
          <CaretRightFill size={20} color="white" />
        </ArrowButton>
      </div>
      {!selectedShelf && <HelpText alwaysVisible>Wybierz lokalizację magazyn-alejka-regał.</HelpText>}
    </>
  );
};
